import React, { useState } from "react";
import { Link } from "react-router-dom";

//import component
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";



//import images


const Header = (props: any) => {

  const [isClick, setClick] = useState<boolean>(true);

  /*** Sidebar menu icon and default menu set */
  function tToggle() {
    var body = document.body;
    setClick(!isClick);
    if (isClick === true) {
      body.classList.add("sidebar-enable");
      document.body.setAttribute("data-sidebar-size", "sm");
    } else {
      body.classList.remove("sidebar-enable");
      document.body.setAttribute("data-sidebar-size", "lg");
    }
  }

  return (
    <React.Fragment>
      <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex"></div>
          <div className="d-flex">
            <ProfileMenu />
          </div>
        </div>
      </header>
      
    </React.Fragment>
      
    </React.Fragment>
  );
};

export default Header;
